import { RouteConfig } from "vue-router";

const routes: RouteConfig[] = [
  {
    path: "databases/:databaseId/stats",
    component: () =>
      import(/* webpackChunkName: "doctor" */ "views/Stats/Index.vue"),
    name: "stats_index",
    meta: { role: ["doctor", "supervisor", "admin", "superadmin"] },
  },
  {
    path: "databases/:databaseId/stats/:templateId",
    component: () =>
      import(/* webpackChunkName: "doctor" */ "views/Stats/Show.vue"),
    name: "stats_show",
    meta: { role: ["doctor", "supervisor", "admin", "superadmin"] },
  },
];

export default routes;
